import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import "./Header.scss";

import top_left from "../Images/top_left.png";
import top_right from "../Images/top_right.png";
import logo from "../Images/logo.png";
import hover_knop from "../Images/H0_menu hoofdstukknoppen-03.png"
import knop from "../Images/H0_menu hoofdstukknoppen-04.png"

import arrow_up from "../Images/arrow_up.png";
import arrow_down from "../Images/arrow_down.png";
import line_left from "../Images/line_left.png";
import line_right from "../Images/line_right.png";

import video_button from "../Images/video_button.png";
import video_button_selected from "../Images/video_button_selected.png";
import video_button_wide from "../Images/video_button_wide.png";
import video_button_wide_selected from "../Images/video_button_wide_selected.png";
import video_button_small from "../Images/video_button_small.png";
import video_button_small_selected from "../Images/video_button_small_selected.png";
import book_button from "../Images/book_button.png";
import book_button_selected from "../Images/book_button_selected.png";
import book_button_wide from "../Images/book_button_wide.png";
import book_button_wide_selected from "../Images/book_button_wide_selected.png";
import drawer_button from "../Images/drawer_button.png";
import drawer_button_selected from "../Images/drawer_button_selected.png";
import drawer_button_wide from "../Images/drawer_button_wide.png";
import drawer_button_wide_selected from "../Images/drawer_button_wide_selected.png";

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isHovered: "",
      chaptersAreOpen: false,
      chapters: [
        {
          index: 0,
          title: "Hoofdstuk 1",
          subtitle: "Inleiding",
          link: "/1/Inleiding"
        },
        {
          index: 1,
          title: "Hoofdstuk 2",
          subtitle: "Boek",
          link: "/2/het-boek"
        },
        {
          index: 2,
          title: "Hoofdstuk 3",
          subtitle: "Gemeenschappen",
          link: "/3/mayu"
        },
        {
          index: 3,
          title: "Hoofdstuk 4",
          subtitle: "Bomen in België",
          link: "/4/belgie"
        },
        {
          index: 4,
          title: "Hoofdstuk 5",
          subtitle: "Het woud redden",
          link: "/5/wat-kunnen-wij-doen"
        }
      ],
      chapter_buttons: [
        [
          {
            type: "VIDEO",
            text: "Inleiding",
            link: "/1/Inleiding"
          },
          {
            type: "VIDEO_WIDE",
            text: "Het Amazonewoud",
            link: "/1/het-amazonewoud"
          },
          {
            type: "DRAWER",
            text: "De Dieren",
            link: "/1/de-dieren"
          }
        ],
        [
          {
            type: "VIDEO",
            text: "Het boek",
            link: "/2/het-boek"
          },
          {
            type: "BOOK_WIDE",
            text: "Het verhaal van Mascopiro",
            link: "/2/het-verhaal-van-mascopiro"
          }
        ],
        [
          {
            type: "VIDEO_SMALL",
            text: "Mayu",
            link: "/3/mayu"
          },
          {
            type: "DRAWER",
            text: "Gemeenschappen",
            link: "/3/gemeenschappen"
          },
          {
            type: "VIDEO_SMALL",
            text: "Mayu II",
            link: "/3/mayu-ii"
          },
          {
            type: "VIDEO_SMALL",
            text: "Mayu III",
            link: "/3/mayu-iii"
          },
          {
            type: "DRAWER",
            text: "De boskoffer",
            link: "/3/de-boskoffer"
          }
        ],
        [
          {
            type: "VIDEO_SMALL",
            text: "België",
            link: "/4/belgie"
          },
          {
            type: "DRAWER_WIDE",
            text: "Bomen in België",
            link: "/4/bomen-in-belgie"
          }
        ],
        [
          {
            type: "VIDEO_WIDE",
            text: "Wat kunnen wij doen?",
            link: "/5/wat-kunnen-wij-doen",
          },
          {
            type: "DRAWER_WIDE",
            text: "Het woud redden",
            link: "/5/het-woud-redden",
          },
          {
            type: "DRAWER_WIDE",
            text: "Einde",
            link: "/5/einde",
          }
        ]
      ]
    };
  }
  render() {
    const {
      chaptersAreOpen,
      chapters,
      chapter_buttons,
      isHovered
    } = this.state;
    let chapter = parseInt(window.location.pathname.substr(1, 1)) - 1;
    if (isNaN(chapter)) {
      chapter = -1;
    }
    const url = window.location.pathname;
    const buttons = chapter == -1 ? [] : chapter_buttons[chapter];
    return (
      <>
        <div className="header">
          <img className="top_left" src={top_left} alt="" />
          <img className="top_right" src={top_right} alt="" />
          <nav>
            <a href="/">
              <img className="logo" alt="" src={logo} />
            </a>
            {/*<div
            className="select"
            onMouseEnter={() => {
              this.setState({
                chaptersAreOpen: true
              });
            }}
            onMouseLeave={() => {
              this.setState({
                chaptersAreOpen: false
              });
            }}
          >
            {chapters.map((ch, index) => {
              if (index !== chapter && !chaptersAreOpen) {
                return null;
              }
              return (
                <div
                  key={ch.title}
                  className={chaptersAreOpen ? "option is-open" : "option"}
                  onClick={() => (window.location = ch.link)}
                >
                  <img className="line left" src={line_left} alt="" />
                  <span>
                    {ch.title + ": "}
                    <br />
                    <strong>{ch.subtitle}</strong>
                  </span>
                  <img className="line right" src={line_right} alt="" />
                </div>
              );
            })}
            {!chaptersAreOpen && (
              <div className="arrow">
                <img src={arrow_down} alt="" />
              </div>
            )}
            {chaptersAreOpen && (
              <div className="arrow">
                <img src={arrow_up} alt="" />
              </div>
            )}
          </div> */}
            <div className="chapters">
              {chapters.map(ch => {
                console.log(chapter)
                return (
                  <div
                    key={ch.title}
                    className={"menu_item"}
                    style={{backgroundImage: `url("${chapter == ch.index ? hover_knop : knop}")`}}
                    onClick={() => (window.location = ch.link)}
                  >
                    <span className={"menu_text"}>
                      {ch.title + ": "}
                      <br />
                      <strong>{ch.subtitle}</strong>
                    </span>
                  </div>
                );
              })}
            </div>
          </nav>
        </div>
        {chapter == -1 ? null : <div className="sub_menu">
          <div className="buttons">
            {buttons.map(button => {
              let img_src, img_src_hover;
              switch (button.type) {
                case "DRAWER":
                  img_src = drawer_button;
                  img_src_hover = drawer_button_selected;
                  break;
                case "DRAWER_WIDE":
                  img_src = drawer_button_wide;
                  img_src_hover = drawer_button_wide_selected;
                  break;
                case "VIDEO":
                  img_src = video_button;
                  img_src_hover = video_button_selected;
                  break;
                case "VIDEO_WIDE":
                  img_src = video_button_wide;
                  img_src_hover = video_button_wide_selected;
                  break;
                case "VIDEO_SMALL":
                  img_src = video_button_small;
                  img_src_hover = video_button_small_selected;
                  break;
                case "BOOK":
                  img_src = book_button;
                  img_src_hover = book_button_selected;
                  break;
                case "BOOK_WIDE":
                  img_src = book_button_wide;
                  img_src_hover = book_button_wide_selected;
                  break;
                default:
                  img_src = video_button;
                  img_src_hover = video_button_selected;
                  break;
              }
              var st = "";
              if (button.widst) {
                st = "widst";
              }
              if (button.wider) {
                st = "wider";
              }
              if (button.smaller) {
                st = "smaller";
              }
              return (
                <button
                  key={button.text}
                  className={st}
                  onClick={() => this.props.history.push(button.link)}
                  onMouseEnter={() =>
                    this.setState({
                      isHovered: button.link
                    })
                  }
                  onMouseLeave={() =>
                    this.setState({
                      isHovered: null
                    })
                  }
                >
                  {/* <img src={img_src} alt="Type" className="button_icon" /> */}
                  <img
                    src={
                      button.link === url || button.link === isHovered
                        ? img_src_hover
                        : img_src
                    }
                    alt="button"
                  />
                  <span
                    className={
                      button.link === url || button.link === isHovered
                        ? "dark"
                        : ""
                    }
                  >
                    {button.text}
                  </span>
                </button>
              );
            })}
          </div>
        </div>}
      </>
    );
  }
}

export default withRouter(Header);
